module.exports = new __parcel__URL__("shop_buy_swap_button_inactive.e29586ae.png").toString();